export default "__VITE_ASSET__D$q4Te6o__"